import axios from 'axios';


export const initSettingsModals = () => {
    document.addEventListener('DOMContentLoaded', function() {
    //   insertBirthday();
      initEmailSubmit();
      initUpdatePage();
    //   appendSocialMessage();
  
      var returnBtns = document.querySelectorAll('.return-btn');
      if (returnBtns) {
        returnBtns.forEach(function(returnBtn) {
          returnBtn.addEventListener('click', function() {
            hideMask();
          });
        });
      }
  
      var clickableFields = document.querySelectorAll('.clickable-field');
      if (clickableFields) {
        clickableFields.forEach(function(clickableField) {
          clickableField.addEventListener('click', function(e) {
            fadeBackground();
            if (e.currentTarget.classList.contains('birthday-field')) {
              document.querySelector('.birthday-modal').style.display = 'block';
              document.querySelector('.lastname-modal').style.display = 'none';
              document.querySelector('.firstname-modal').style.display = 'none';
              document.querySelector('.gender-modal').style.display = 'none';
              document.querySelector('.marketing-modal').style.display = 'none';
              document.querySelector('.email-modal').style.display = 'none';
            } else if (e.currentTarget.classList.contains('lastname-field')) {
              document.querySelector('.lastname-modal').style.display = 'block';
              document.querySelector('.birthday-modal').style.display = 'none';
              document.querySelector('.firstname-modal').style.display = 'none';
              document.querySelector('.gender-modal').style.display = 'none';
              document.querySelector('.marketing-modal').style.display = 'none';
              document.querySelector('.email-modal').style.display = 'none';
            } else if (e.currentTarget.classList.contains('firstname-field')) {
              document.querySelector('.firstname-modal').style.display = 'block';
              document.querySelector('.lastname-modal').style.display = 'none';
              document.querySelector('.birthday-modal').style.display = 'none';
              document.querySelector('.gender-modal').style.display = 'none';
              document.querySelector('.marketing-modal').style.display = 'none';
              document.querySelector('.email-modal').style.display = 'none';
            } else if (e.currentTarget.classList.contains('gender-field')) {
              document.querySelector('.gender-modal').style.display = 'block';
              document.querySelector('.firstname-modal').style.display = 'none';
              document.querySelector('.lastname-modal').style.display = 'none';
              document.querySelector('.birthday-modal').style.display = 'none';
              document.querySelector('.marketing-modal').style.display = 'none';
              document.querySelector('.email-modal').style.display = 'none';
            } else if (e.currentTarget.classList.contains('marketing-field')) {
              document.querySelector('.marketing-modal').style.display = 'block';
              document.querySelector('.gender-modal').style.display = 'none';
              document.querySelector('.firstname-modal').style.display = 'none';
              document.querySelector('.lastname-modal').style.display = 'none';
              document.querySelector('.birthday-modal').style.display = 'none';
              document.querySelector('.email-modal').style.display = 'none';
            } else if (e.currentTarget.classList.contains('email-field')) {
              document.querySelector('.email-modal').style.display = 'block';
              document.querySelector('.marketing-modal').style.display = 'none';
              document.querySelector('.gender-modal').style.display = 'none';
              document.querySelector('.firstname-modal').style.display = 'none';
              document.querySelector('.lastname-modal').style.display = 'none';
              document.querySelector('.birthday-modal').style.display = 'none';
            }
          });
        });
      }
    });
}

// const insertBirthday = () => {
    // var birthdayField = document.getElementById('birthday-input');
    // const picker = datepicker(birthdayField, {
    //     formatter: (input, date, instance) => {
    //         // This will display the date as `1/1/2019`.
    //         const year = date.getFullYear();
    //         const month = ('00' + (date.getMonth()+1)).slice(-2);
    //         const day = ('00' + date.getDate()).slice(-2);
    //         const formattedDate = `${year}-${month}-${day}`;
    //         input.value = formattedDate;
    //         console.log(input.value);
    //     },
    //     startDate: new Date(1990, 1, 1)
    // });
// }

const initEmailSubmit = () => {
    var emailButton = document.querySelector('.email--button');
    if (emailButton) {
      emailButton.addEventListener('click', function(e) {
        e.preventDefault();
        var email1 = document.querySelector('.Email1').value;
        var email2 = document.querySelector('.Email2').value;
        let customerId = parseInt(document.querySelector('input[name=customer-id]').value);
        let hmac = document.querySelector("input[name=hmac]").value;
        if (email1 === email2) {
          e.preventDefault();
          var email = document.querySelector("input[name='customer[setting-email]']").value;
          var request = JSON.stringify({
            customerId: customerId,
            hmac: hmac,
            email: email
          });
      
          axios.post(API_URL.updateCustomerFields, request)
            .then(function(response) {
              //console.log(response);
              hideMask();
            })
            .catch(function(error) {
              // error handling
              var error_msg = error.response.data;
              document.querySelector("#email_error").textContent = error_msg;
            });
      
          document.querySelector('.email-field span').textContent = email;
          document.querySelector('.email-preview').textContent = email;
        } else {
          alert("メールアドレスが一致しません");
        }
      });
    }
}
  
const initUpdatePage = () => {
    var customerId = parseInt(document.querySelector('input[name=customer-id]').value);
    var hmac = document.querySelector("input[name=hmac]").value;
  
    document.querySelector('#firstname-form').addEventListener("submit", function(e) {
      e.preventDefault();
      var firstname = document.querySelector("input[name='customer[first_name]']").value;
      var request = JSON.stringify({
        customerId: customerId,
        hmac: hmac,
        first_name: firstname
      });
  
      axios.post(API_URL.updateCustomerFields, request)
        .then(function(response) {
          //console.log(response);
        })
        .catch(function(error) {
          // error handling
        });
  
      hideMask();
      document.querySelector('.firstname-field span').textContent = firstname;
    });
  
    document.querySelector('#lastname-form').addEventListener("submit", function(e) {
      e.preventDefault();
      var lastname = document.querySelector("input[name='customer[last_name]']").value;
      var request = JSON.stringify({
        customerId: customerId,
        hmac: hmac,
        last_name: lastname
      });
  
      axios.post(API_URL.updateCustomerFields, request)
        .then(function(response) {
          //console.log(response);
        })
        .catch(function(error) {
          // error handling
        });
  
      hideMask();
      document.querySelector('.lastname-field span').textContent = lastname;
    });
  
    // document.querySelector('#email-form-test').addEventListener("submit", function(e) {
    //   console.log('test');
    //   e.preventDefault();
    //   var email = document.querySelector("input[name='test[setting-email]']").value;
    //   var request = JSON.stringify({
    //     customerId: customerId,
    //     hmac: hmac,
    //     email: email
    //   });
  
    //   axios.post(API_URL.updateCustomerFields, request)
    //     .then(function(response) {
    //       //console.log(response);
    //       hideMask();
    //     })
    //     .catch(function(error) {
    //       // error handling
    //       var error_msg = error.response.data;
    //       document.querySelector("#email_error").textContent = error_msg;
    //     });
  
    //   document.querySelector('.email-field span').textContent = email;
    //   document.querySelector('.email-preview').textContent = email;
    // });
  
    document.querySelector('#birthday-form').addEventListener("submit", function(e) {
      e.preventDefault();
      var birthday = document.querySelector('#birthday-input').value;
      var request = JSON.stringify({
        customerId: customerId,
        hmac: hmac,
        birthdate: birthday
      });
  
      hideMask();
  
      axios.post(API_URL.updateCustomerFields, request)
        .then(function(response) {
          //console.log(response);
        });
  
      document.querySelector('.birthday-field span').textContent = birthday.split('-').join('/');
    });
  
    document.querySelector('#gender-form').addEventListener("submit", function(e) {
      e.preventDefault();
      var gender = document.querySelector("input[name=customer-gender]:checked").value;
      var request = JSON.stringify({
        customerId: customerId,
        hmac: hmac,
        gender: gender
      });
  
      hideMask();
  
      axios.post(API_URL.updateCustomerFields, request)
        .then(function(response) {
          //console.log(response);
        });
  
      if (gender == '男性') {
        document.querySelector('.gender-field span').textContent = '男性';
      } else if (gender == '女性') {
        document.querySelector('.gender-field span').textContent = '女性';
      } else {
        document.querySelector('.gender-field span').textContent = 'その他';
      }
    });
  
    document.querySelector('#marketing-form').addEventListener("submit", function(e) {
      e.preventDefault();
      var acceptsMarketing = document.querySelector("input[name='customer[accepts_marketing]']:checked").value;
      var myBool = (acceptsMarketing.toLowerCase() === 'true');
      var request = JSON.stringify({
        customerId: customerId,
        hmac: hmac,
        accepts_marketing: myBool
      });
  
      axios.post(API_URL.updateCustomerFields, request)
        .then(function(response) {
          //console.log(response);
        });
  
      hideMask();
      if (acceptsMarketing == 'true') {
        document.querySelector('.marketing-field span').textContent = '購読する';
      } else {
        document.querySelector('.marketing-field span').textContent = '購読しない';
      }
    });
}

const hideMask = () => {
    document.querySelector('.page-mask').style.display = 'none';
    document.querySelector('x-header').classList.remove('faded');
    // document.querySelector('.Header__CartDot').classList.remove('faded-dot');
    // document.querySelector('.Button--primary').classList.remove('faded-text');
    var modals = document.querySelectorAll('.modal');
    for (var i = 0; i < modals.length; i++) {
      modals[i].style.display = 'none';
    }
}

const fadeBackground = () => {
    document.querySelector('.page-mask').style.display = 'block';
    document.querySelector('x-header').classList.add('faded');
    // document.querySelector('.Header__CartDot').classList.add('faded-dot');
    // document.querySelector('.Button--primary').classList.add('faded-text');
  
    document.querySelector('.page-mask').addEventListener('click', function(e) {
      if (e.target.classList.contains('page-mask')) {
        hideMask();
      }
    });
}
  
  